<template>
  <modal :visible="visible" @close="close">
    <div class="box">
      <article class="media">
        <div class="media-content">
          <div class="heading">
            <h4>
              {{title}}
            </h4>
          </div>
          <p v-if="clipboard" class="control">
            <textarea v-model="clipboardArea" class="textarea" :placeholder="$t('campaigns.putBaseFromClipboard')"></textarea>
          </p>
          <div class="content">
            <button v-if="confirmation" class="button is-primary" @click="$emit('confirm')">{{$t('common.yes')}}</button>
            <button v-if="confirmation" class="button is-light" @click="$emit('close')">{{$t('common.no')}}</button>
            <button v-if="clipboard" class="button is-primary" @click="$emit('confirm', clipboardArea)">ОК</button>
            <button v-if="clipboard" class="button is-light" @click="$emit('close')">{{$t('common.actions.cancel')}}</button>
          </div>
        </div>
      </article>
    </div>
  </modal>
</template>


<script>
  import { Modal } from 'vue-bulma-modal'

  export default {
    components: {
      Modal
    },

    props: {
      visible: Boolean,
      title: String,
      confirmation: Boolean,
      clipboard: Boolean,
      clipboardArea: ''
    },

    methods: {
      close () {
        this.$emit('close')
      }
    }
  }

</script>
<style>
  .modal {
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
  }
  .modal .modal-body {
    text-align: center;
    padding-top: 20px;
    width: 300px;
    height: 100px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// Modal.vue?c8103db0